import type { JSX, ReactNode } from 'react';
import styled from 'styled-components';
import { Stack, Image } from '@wistia/ui';
import hubspot from './icons/hubspot.svg';
import adobe from './icons/adobe.svg';
import pardot from './icons/pardot.svg';
import meta from './icons/meta.png';

const Chip = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-radius: 100%;
  box-shadow: 0 1px 3px 0 #0000001a;
  padding: 3px;

  &:not(:first-child) {
    margin-left: -6px;
  }
`;

const IconChip = ({ src, alt }: { src: string; alt: string }): JSX.Element => (
  <Chip>
    <Image
      src={src}
      alt={alt}
    />
  </Chip>
);

const IconChipStack = ({ children }: { children: ReactNode }): JSX.Element => (
  <Stack
    direction="horizontal"
    gap="space-00"
  >
    {children}
  </Stack>
);

export const MarketingIntegrationIcons = (): JSX.Element => (
  <IconChipStack>
    <IconChip
      src={hubspot}
      alt="Hubspot"
    />
    <IconChip
      src={adobe}
      alt="Adobe"
    />
    <IconChip
      src={pardot}
      alt="Salesforce Pardot"
    />
  </IconChipStack>
);

export const AdPlatformIntegrationIcons = (): JSX.Element => (
  <IconChipStack>
    <IconChip
      src={meta}
      alt="Meta"
    />
  </IconChipStack>
);
